module.exports = {"340212100":"繁阳镇","340212101":"荻港镇","340212102":"孙村镇","340212103":"平铺镇","340212104":"新港镇","340212105":"峨山镇","340212401":"安徽繁昌工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340212.json
// module id = 1156
// module chunks = 0